import { render, staticRenderFns } from "./TableDetalleOrden.vue?vue&type=template&id=110ba5fd&"
import script from "./TableDetalleOrden.vue?vue&type=script&lang=js&"
export * from "./TableDetalleOrden.vue?vue&type=script&lang=js&"
import style0 from "./TableDetalleOrden.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports